module.exports = __webpack_public_path__ + "static/img/img1.16be706.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/img1.png
// module id = ks4B
// module chunks = 5